import { createContext } from 'react';
import { AdminDashboardFilters } from '../../types';

type AdminDashboardContextType = {
  viewTabIndex: string;
  handleViewTabChange: (index: string) => void;
  entityTabIndex: string;
  handleEntityTabChange: (event: React.SyntheticEvent, index: string) => void;
  filters: AdminDashboardFilters;
  handleFilterChange: (filters: Partial<AdminDashboardFilters>) => void;
};

export const AdminDashboardContext = createContext<AdminDashboardContextType>({
  viewTabIndex: '1',
  handleViewTabChange: () => {},
  entityTabIndex: '1',
  handleEntityTabChange: () => {},
  filters: {
    roles: [],
    users: [],
    teams: [],
    interval: 'all_time',
    to_date: '',
    from_date: '',
    supervisor_ids: [],
    record_ids: [],
  },
  handleFilterChange: () => {},
});
